import { render } from "./ConfigValue.vue?vue&type=template&id=6e871923"
import script from "./ConfigValue.vue?vue&type=script&lang=js"
export * from "./ConfigValue.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__